<template>
  <section class="ag-studio-toolbar" aria-label="Agent studio">
    <div class="ag-studio-toolbar__start">
      <v-btn
        v-if="showTrainKnowledge"
        variant="flat"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--primary"
        prepend-icon="mdi-pencil-outline"
        :disabled="!isSessionReady"
        @click="$emit('train')"
      >
        Edit Knowledgebase
      </v-btn>
    </div>

    <nav class="ag-studio-toolbar__tabs" aria-label="Agent studio sections">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        type="button"
        class="ag-studio-toolbar__tab"
        :class="{ 'ag-studio-toolbar__tab--active': modelValue === tab.value }"
        :aria-current="modelValue === tab.value ? 'page' : undefined"
        @click="$emit('update:modelValue', tab.value)"
      >
        <span class="ag-studio-toolbar__tab-icon">
          <v-icon :icon="tab.icon" size="15" />
        </span>
        <span>{{ tab.title }}</span>
      </button>
    </nav>
  </section>
</template>

<script setup>
defineOptions({ name: 'AgentCommandCenter' })

defineProps({
  modelValue: { type: String, required: true },
  tabs: { type: Array, default: () => [] },
  showTrainKnowledge: { type: Boolean, default: false },
  isSessionReady: { type: Boolean, default: false },
})

defineEmits(['update:modelValue', 'train'])
</script>
